/**
 * Merges the user config with the default one, to update new values and keep
 * defaults where necessary
 * @param  {object} defaultConfig default user config
 * @param  {object} userConfig    current user config
 * @return {object}               merged user config
 */
// eslint-disable-next-line
export const mergeWithDefaultConfig = (defaultConfig, userConfig) => {
  const dConfig = defaultConfig || {};

  if (!userConfig) {
    return dConfig;
  }
  return Object.keys(userConfig).reduce((previous, current) => {
    const prev = previous;
    if (userConfig[current] !== 'default') {
      prev[current] = userConfig[current];
    }
    return prev;
  }, dConfig);
};



// WEBPACK FOOTER //
// ./app/util/userConfig.js